import React, { useState } from 'react'
import "./BattlePass.css"
import styled from "styled-components";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import { useHistory } from 'react-router';
import Fade from 'react-reveal/Fade';
import Slide from 'react-reveal/Slide';
import Bounce from 'react-reveal/Bounce';
import Wobble from 'react-reveal/Wobble';

function BattlePass() {
    const history = useHistory();

    let settings = {
        infinite: true,
        fade: true,
        speed: 200,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
    };
    return (
        <>
            <div className="battlePass">

                <div className="battlepass_video">
                    <video muted loop controls autoPlay   >
                        <source src="/video/video1.mp4" type="video/mp4" />
                    </video>
                </div>


                <div className="battlepass_midimg">
                    <img src="https://cdn2.unrealengine.com/fortnite-chapter-2-season-8-battle-pass-characters-bg-2880x2241-f4710adffd1b.jpg" alt="" />
                </div>
        

                <Slide left>

                    <div className="battle_pass_stars ">
                        <img src="https://cdn2.unrealengine.com/battlepass-battlestar-277x252-579065405.png" alt="" />
                    </div>
                </Slide>


                <Fade bottom cascade>
                    <div className="battlepass_info">
                        <p>ENTER THE SIDEWAYS
                        </p>
                    </div>
                </Fade>

                <Fade bottom cascade>
                    <div className="battlepass__own">
                        <p>MY SELF - TORIN</p>
                    </div>
                </Fade>




                {/* logo png images1 */}
                <Slide left>

                    <div className="slider_subimg_logo1 ">
                        <img src="https://cdn2.unrealengine.com/18-bling-bp-datafiberchargepack-sideways-295x252-8bf8152021d7.png" alt="" />
                    </div>
                </Slide>

                {/* logo png images2 */}
                <Slide left>
                    <div className="slider_subimg_logo2  ">
                        <img src="https://cdn2.unrealengine.com/18-screen-loading-bp-dimensionofdanger-3d-307x245-be5d61fa0fe7.png" alt="" />
                    </div>
                </Slide>

                {/* logo png images3 */}
                <Slide right>

                    <div className="slider_subimg_logo3">
                        <img src="https://cdn2.unrealengine.com/18-spray-bp-hunter-screst-236x260-1ede09dcad6e.png" alt="" />
                    </div>
                </Slide>

                {/* logo png images4 */}
                <Slide right>
                    <div className="slider_subimg_logo4 ">
                        <img src="https://cdn2.unrealengine.com/18-axe-bp-torin-slightblade-sideways-295x451-dab25e6de901.png" alt="" />
                    </div>
                </Slide>

                <Carousel {...settings}>

                    <Wrap>
                        <a>
                            <img
                                src="https://cdn2.unrealengine.com/fortnite-chapter-2-season-8-battle-pass-hero-torin-variant1-2080x2136-2d8cb0bd76f6.png" alt="" />
                        </a>
                    </Wrap>

                    <Wrap>
                        <a>
                            <img
                                src="https://cdn2.unrealengine.com/fortnite-chapter-2-season-8-battle-pass-hero-torin-variant2-2080x2136-233d2e11a538.png" alt="" />
                        </a>
                    </Wrap>

                    <Wrap>
                        <a>
                            <img
                                src="https://cdn2.unrealengine.com/fortnite-chapter-2-season-8-battle-pass-hero-torin-variant3-2080x2136-d280d7f93543.png" alt="" />
                        </a>
                    </Wrap>

                    <Wrap>
                        <a>
                            <img
                                src="https://cdn2.unrealengine.com/fortnite-chapter-2-season-8-battle-pass-hero-torin-variant4-2080x2136-a60a53ec52ea.png" alt="" />
                        </a>
                    </Wrap>

                </Carousel>
                <Fade bottom>

                    <div className="allCharcters">
                        <li>
                            <img src="https://cdn2.unrealengine.com/fortnite-chapter-2-season-8-battle-pass-hero-torin-icon-200x200-fcc83289e138.png" alt="" /></li>


                        <li> <img onClick={() => history.push("/venom")} src="https://cdn2.unrealengine.com/fortnite-chapter-2-season-8-battle-pass-hero-carnage-icon-200x200-e29af7b2c41a.png" alt="" />
                        </li>

                        <li><img onClick={() => history.push("/fabio")} src="https://cdn2.unrealengine.com/fortnite-chapter-2-season-8-battle-pass-hero-fabio-sparklemane-icon-200x200-9fbb3df9185e.png" alt="" /></li>

                        <li><img onClick={() => history.push("/chimpanski")} src="https://cdn2.unrealengine.com/fortnite-chapter-2-season-8-battle-pass-hero-j-b-chimpaski-icon-200x200-fb7893c001b6.png" alt="" /></li>

                        <li><img onClick={() => history.push("/charlotte")} src="https://cdn2.unrealengine.com/fortnite-chapter-2-season-8-battle-pass-hero-charlotte-icon-200x200-fa6c31aa1cbc.png" alt="" /></li>

                        <li><img onClick={() => history.push("/kor")} src="https://cdn2.unrealengine.com/fortnite-chapter-2-season-8-battle-pass-hero-kor-icon-200x200-f46f82b33869.png" alt="" /></li>

                        <li><img onClick={() => history.push("/toonafish")} src="https://cdn2.unrealengine.com/fortnite-chapter-2-season-8-battle-pass-hero-toona-fish-icon-200x200-0fc5188e1c83.png" alt="" /></li>

                        <li><img onClick={() => history.push("/coomingSoon")} src="https://cdn2.unrealengine.com/fortnite-chapter-2-season-8-battle-pass-hero---icon-200x200-5d7efdd11e0b.png" alt="" /></li>

                    </div>
                </Fade>

                <div className="bucks">

                    <Slide left>
                        <div className="buck_left">
                            <img src="https://cdn2.unrealengine.com/v-bucks-coins-left-1184x1234-2f1319541651.png" alt="" />
                        </div>
                    </Slide>

                    <div className="column">
                        <div className="buck_mid">
                            <p>1500 V-BUCKS BACK</p>
                        </div>


                        <div className="buck_mid_des">
                            <p>GET THE BATTLE PASS FOR ONLY 950 V-BUCKS AND EARN UP TO 1500 V-BUCKS BY PLAYING. USE THEM TO BUY THE NEXT BATTLE PASS OR ITEMS FROM THE ITEM SHOP.</p>
                        </div>
                    </div>

                    <Slide right>
                        <div className="buck_right">
                            <img src="https://cdn2.unrealengine.com/v-bucks-coins-right-1230x1296-5853f818e449.png" alt="" />
                        </div>
                    </Slide>

                </div>

                <div className="learn">

                    <div className="left_learn">
                        <img src="https://cdn2.unrealengine.com/fortnite-chapter-2-season-8-crew-featured-character-2066x1952-0f2cadd9a3af.png" alt="" />
                    </div>

                    <div className="learn_des">
                        <div className="right_learn">
                            <img src="https://cdn2.unrealengine.com/en-1743x759-fcffcc487f40.png" alt="" />
                        </div>

                        <br />


                        <Slide bottom>
                            <div className="des1">
                                <p>ALSO AVAILABLE WITH THE FORTNITE CREW</p>
                            </div>
                        </Slide>

                        <Slide bottom>
                            <div className="des2">
                                <p>THE FORTNITE CREW IS THE ULTIMATE SUBSCRIPTION OFFER THAT INCLUDES THE BATTLE PASS, 1,000 MONTHLY V-BUCKS, AND AN EXCLUSIVE MONTHLY FORTNITE CREW PACK.</p>
                            </div>
                        </Slide>

                        <Slide bottom>
                            <div className="des_btn">
                                <p>LEARN MORE</p>
                            </div>
                        </Slide>
                    </div>

                </div>
                <div className="battlePass_end">
                    <img src="https://cdn2.unrealengine.com/fortnite-chapter-2-season-8-seasonal-details-bg-2881x1625-fe82d635e0c8.jpg" alt="" />



                    <div className="battlePass_end_name">
                        <Bounce bottom cascade>
                            <p>SEASON 8</p>
                        </Bounce>
                    </div>


                    <Wobble>

                        <div className="battlePass_end_image">
                            <img src="https://cdn2.unrealengine.com/cubed-logo-en-763x198-ea5d7a3d29bb.png" alt="" />
                        </div>
                    </Wobble>
                    <Slide bottom>
                        <div className="battlePass_end_des">
                            <p>THE CUBE HAS RETURNED, BUT NOW THERE’S… MORE OF THEM. FROM THE SMOLDERING WRECKAGE OF THE MOTHERSHIP A NEW THREAT ARISES. CUBES ARE WAKING UP, SPREADING CORRUPTION, AND CREATING RIFTS TO “THE SIDEWAYS”. ENTER THE SIDEWAYS TO TAKE ON MONSTERS AND FIND SIDEWAYS WEAPONS. JOIN THE COMMUNITY EFFORT TO BUILD DEFENSIVE MEASURES AGAINST THE CUBES. IT’S UP TO YOU - ALL OF YOU - TO FIGHT FOR THE ISLAND’S SURVIVAL.
                                JOIN THE COMMUNITY EFFORT TO BUILD DEFENSIVE MEASURES AGAINST THE CUBES. IT’S UP TO YOU - ALL OF YOU - TO FIGHT FOR THE ISLAND’S SURVIVAL.

                            </p>
                        </div>
                    </Slide>

                    <Slide bottom>
                        <div className="battlePass_end_btn">
                            <p>PLAY FREE NOW</p>
                        </div>
                    </Slide>
                </div>
            </div>
        </>

    );
};

export default BattlePass



const Carousel = styled(Slider)`
::-webkit-scrollbar {
    width: 0;
  }
 
  @media all and (max-width: 1400px) and (min-width: 1000px) {
    margin-top: -1360px;


}

@media all and (max-width: 1100px) and (min-width: 839px) {
    margin-top: -840px;
    margin-left:auto;
    margin-right:auto;
    text-align:center;
    margin-left:0px;

}
@media all and (max-width: 839px){
    margin-top: -1760px;
    margin-left:30px;

}
@media all and (max-width: 800px){
    margin-top: -1520px;
  
}
@media all and (max-width: 600px){
    margin-top: -1360px;
    
}
@media all and (max-width: 435px) {
    margin-top: -1450px;

}
  
  margin-top: -1660px;
  margin-bottom: 220px
  margin-left:150px;
 overflow-X:hidden; 

  & > button {
    opacity: 0;
    height: 100%;
    width: 5vw;
    z-index: 1;

    &:hover {
      opacity: 1;
      transition: opacity 0.2s ease 0s;
    }
  }

  ul li button {
    &:before {
      font-size: 10px;
      color: rgb(150, 158, 171);
    }
  }

  li.slick-active button:before {
    color: white;
  }

  .slick-list {
    overflow: initial;
  }

  .slick-prev {
    left: -75px;
  }

  .slick-next {
    right: -75px;
  }
`;



const Wrap = styled.div`
  border-radius: 4px;
  cursor: pointer;
  position: relative;
  ::-webkit-scrollbar {
    width: 0;
  }
  

  a {
    border-radius: 4px;

    cursor: pointer;
    display: block;
    position: relative;
    padding: 4px;

    img {
      width: 60%;
      margin-left:auto;
      margin-right:auto;
    }
      
      @media all and (max-width: 435px) {
        img {
            width:100%;
        }
    }
`;
